"use client";

import { c as _c } from "react/compiler-runtime";
import { SeoHeading } from "@/components/common/seo-heading";
import dynamic from "next/dynamic";
const RequestCallbackForm = dynamic(() => import("@/components/forms/request-callback-form").then(mod => mod.RequestCallbackForm), {
  ssr: false
});
import { Section } from "@/components/section";
import { Avatar } from "@/components/ui/avatar";
import { Box } from "@/components/ui/box";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Text } from "@/components/ui/text";
import { checkFirstString } from "@/helpers/email-phone-link";
import { hasData } from "@/helpers/has-data";
import { MailIcon, PhoneIcon } from "lucide-react";
import { Suspense, useState } from "react";
type QueriesProps = {
  section?: PageSections;
  data?: {
    heading?: string;
    seoHeading?: string;
    subHeading?: string;
    buttonText?: string;
    buttonAction?: string;
    email?: string;
    phoneNumber?: string;
  };
};
export default function CommonRequestCallback(t0) {
  const $ = _c(46);
  const {
    data,
    section
  } = t0;
  const [open, setOpen] = useState(false);
  if (!hasData(data)) {
    return null;
  }
  const t1 = `${section?.sectionClass} dark:bg-background bg-slate-100`;
  const t2 = section?.sectionId;
  const t3 = data?.heading;
  const t4 = data?.seoHeading;
  let t5;
  if ($[0] !== t3 || $[1] !== t4) {
    t5 = <SeoHeading heading={t3} seoHeading={t4} />;
    $[0] = t3;
    $[1] = t4;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const t6 = data?.subHeading;
  let t7;
  if ($[3] !== t6) {
    t7 = <Text className="mb-4">{t6}</Text>;
    $[3] = t6;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t8;
  if ($[5] !== t5 || $[6] !== t7) {
    t8 = <Box>{t5}{t7}</Box>;
    $[5] = t5;
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => setOpen(true);
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  const t10 = data?.buttonText || "Request a callback";
  let t11;
  if ($[9] !== t10) {
    t11 = <Button size="lg" onClick={t9}>{t10}</Button>;
    $[9] = t10;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  let t12;
  if ($[11] !== t11 || $[12] !== t8) {
    t12 = <div>{t8}{t11}</div>;
    $[11] = t11;
    $[12] = t8;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Avatar size="lg" className="text-primary grid size-16! place-content-center"><MailIcon /></Avatar>;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  let t14;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Text className="text-lg font-semibold">Email us</Text>;
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  const t15 = data?.email || "#";
  let t16;
  if ($[16] !== t15) {
    t16 = checkFirstString(t15);
    $[16] = t15;
    $[17] = t16;
  } else {
    t16 = $[17];
  }
  let t17;
  if ($[18] !== t16) {
    t17 = <a href={t16} />;
    $[18] = t16;
    $[19] = t17;
  } else {
    t17 = $[19];
  }
  const t18 = data?.email;
  let t19;
  if ($[20] !== t17 || $[21] !== t18) {
    t19 = <Box className="flex gap-2">{t13}<Box className="flex flex-col gap-2">{t14}<Text className="text-muted-foreground" render={t17}>{t18}</Text></Box></Box>;
    $[20] = t17;
    $[21] = t18;
    $[22] = t19;
  } else {
    t19 = $[22];
  }
  let t20;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <Avatar size="lg" className="text-primary grid size-16! place-content-center"><PhoneIcon /></Avatar>;
    $[23] = t20;
  } else {
    t20 = $[23];
  }
  let t21;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <Text className="text-lg font-semibold">Call us</Text>;
    $[24] = t21;
  } else {
    t21 = $[24];
  }
  const t22 = data?.phoneNumber || "#";
  let t23;
  if ($[25] !== t22) {
    t23 = checkFirstString(t22);
    $[25] = t22;
    $[26] = t23;
  } else {
    t23 = $[26];
  }
  let t24;
  if ($[27] !== t23) {
    t24 = <a href={t23} />;
    $[27] = t23;
    $[28] = t24;
  } else {
    t24 = $[28];
  }
  const t25 = data?.phoneNumber;
  let t26;
  if ($[29] !== t24 || $[30] !== t25) {
    t26 = <Box className="flex gap-2">{t20}<Box className="flex flex-col gap-2">{t21}<Text className="text-muted-foreground" render={t24}>{t25}</Text></Box></Box>;
    $[29] = t24;
    $[30] = t25;
    $[31] = t26;
  } else {
    t26 = $[31];
  }
  let t27;
  if ($[32] !== t19 || $[33] !== t26) {
    t27 = <div className="flex flex-col items-start gap-5 sm:flex-row sm:items-center">{t19}{t26}</div>;
    $[32] = t19;
    $[33] = t26;
    $[34] = t27;
  } else {
    t27 = $[34];
  }
  let t28;
  if ($[35] !== t12 || $[36] !== t27) {
    t28 = <div className="grid gap-5 sm:grid-cols-2">{t12}{t27}</div>;
    $[35] = t12;
    $[36] = t27;
    $[37] = t28;
  } else {
    t28 = $[37];
  }
  let t29;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <DialogContent className="p-0 sm:max-w-2xl"><Suspense><RequestCallbackForm /></Suspense></DialogContent>;
    $[38] = t29;
  } else {
    t29 = $[38];
  }
  let t30;
  if ($[39] !== open) {
    t30 = <Dialog open={open} onOpenChange={setOpen}>{t29}</Dialog>;
    $[39] = open;
    $[40] = t30;
  } else {
    t30 = $[40];
  }
  let t31;
  if ($[41] !== t1 || $[42] !== t2 || $[43] !== t28 || $[44] !== t30) {
    t31 = <Section className={t1} id={t2}>{t28}{t30}</Section>;
    $[41] = t1;
    $[42] = t2;
    $[43] = t28;
    $[44] = t30;
    $[45] = t31;
  } else {
    t31 = $[45];
  }
  return t31;
}